var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256S397.4,0,256,0z M415.8,415.7 c-20.8,20.8-44.9,37.1-71.8,48.4c-27.8,11.8-57.4,17.7-88,17.7c-30.5,0-60.1-6-88-17.7c-26.9-11.4-51.1-27.7-71.8-48.4 c-20.8-20.8-37.1-44.9-48.4-71.8C36,316.1,30,286.5,30,256s6-60.1,17.7-88c11.4-26.9,27.7-51.1,48.4-71.8 c20.9-20.8,45-37.1,71.9-48.5C195.9,36,225.5,30,256,30s60.1,6,88,17.7c26.9,11.4,51.1,27.7,71.8,48.4 c20.8,20.8,37.1,44.9,48.4,71.8c11.8,27.8,17.7,57.4,17.7,88c0,30.5-6,60.1-17.7,88C452.8,370.8,436.5,395,415.8,415.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.6,206.9c-13.2-16.5-31.7-26-49.2-26c-23.1,0-32.9,11-48.9,11c-16.6,0-29.1-11-49.1-11c-19.7,0-40.6,11.9-53.8,32.3 c-18.7,28.7-15.5,82.6,14.7,128.6c10.8,16.4,25.2,34.9,44.1,35.1c16.8,0.2,21.6-10.7,44.3-10.8c22.7-0.1,27,11,43.8,10.8 c18.9-0.2,34.1-20.7,44.9-37.1c7.7-11.7,10.6-17.7,16.6-31C322.3,292.3,315.3,230.6,358.6,206.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.8,162.6c8.4-10.8,14.8-26,12.5-41.6c-13.7,0.9-29.8,9.7-39.1,21.1c-8.5,10.3-15.5,25.6-12.8,40.5 C267.3,183.1,282.8,174.1,291.8,162.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcApple);
export default __webpack_public_path__ + "static/media/Ic_apple.ebbe74d70bed08c28f60b4e844ade01d.svg";
export { ForwardRef as ReactComponent };